// extracted by mini-css-extract-plugin
module.exports = {"container":"UserInfo_container__1KG0K","name":"UserInfo_name__gYzMN","left":"UserInfo_left__3FeJs"};